export default __webpack_public_path__ + "static/media/DNo.25-2.995c8099.jpg";